import { render } from "./PortfolioReport.vue?vue&type=template&id=72aa9c30&scoped=true"
import script from "./PortfolioReport.vue?vue&type=script&lang=js"
export * from "./PortfolioReport.vue?vue&type=script&lang=js"

import "./PortfolioReport.vue?vue&type=style&index=0&id=72aa9c30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aa9c30"]])

export default __exports__